var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert-container"},_vm._l((_vm.alerts),function(alert){return _c('b-alert',{key:alert.id,attrs:{"show":alert.show,"variant":alert.color,"dismissible":"","fade":""},on:{"dismissed":function($event){return _vm.onHideAlert(alert)}}},[_c('div',{domProps:{"innerHTML":_vm._s(alert.message)}})])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }